import { UkolyPage } from './UkolyPage';

interface TasksPageProps {
  selectedTaskId: number | null;
  onSelectTask: (id: number | null) => void;
}

export function TasksPage({ selectedTaskId, onSelectTask }: TasksPageProps) {
  return <UkolyPage selectedTaskId={selectedTaskId} onSelectTask={onSelectTask} />;
}
